import { isString } from './isString';

export const isNonEmptyString = (value: unknown): value is string => {
	return isString(value) && value.length > 0;
};
